import AOS from "aos";
import Blob from "./components/Blob";
import Sliders from "./components/Sliders";
import Quantity from "./components/Quantity";

document.addEventListener("DOMContentLoaded", () => {
	AOS.init();
	Sliders();
	Blob();
	Quantity();

	const burgerWrapper = document.querySelector(".burger-menu");
	const burgerClose = document.querySelector(".burger-menu__close");
	const burgerLines = document.querySelector(".burger-js");
	const deliveries = document.querySelectorAll(".single-product__summary-delivery");
	const toggles = document.querySelectorAll(".category-title-with-icon");
    const searchBtn = document.querySelector('.header__wrapper-right-search');
    const searchBox = document.querySelector('.header__wrapper-search-box');
    const tabs = document.querySelectorAll('.single-product__tabs-nav-item');
    const contents = document.querySelectorAll('.single-product__tabs-content-item');
    const allNotEmptyLinks      = document.querySelectorAll('a[href^="#"]');

    if (tabs.length > 0) {
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const target = tab.dataset.tab;

                tabs.forEach(t => t.classList.remove('active'));
                contents.forEach(c => c.classList.remove('active'));

                tab.classList.add('active');
                document
                    .querySelector(`.single-product__tabs-content-item[data-tab="${target}"]`)
                    ?.classList.add('active');
            });
        });
    }

    if (searchBtn && searchBox) {

        searchBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            searchBox.classList.add('active');
        });

        document.addEventListener('click', function (e) {
            if (!searchBox.contains(e.target) && e.target !== searchBtn) {
                searchBox.classList.remove('active');
            }
        });
    }

    // Scroll smoothly to element with ID
    if (allNotEmptyLinks) {
        allNotEmptyLinks.forEach(anchor => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();

                const targetId = this.getAttribute('href');
                if (targetId && targetId.startsWith('#') && targetId.length > 1) {
                    const targetElement = document.querySelector(targetId);
                    console.log(targetElement)
                    if (targetElement) {
                        const yOffset = -100; // Odstęp 100px od góry
                        const yPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: yPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });
    }

	if (toggles.length > 0) {
		toggles.forEach(function (icon) {
			icon.addEventListener("click", function (e) {
				e.preventDefault();
				const li = icon.closest(".cat-item");
				const box = li ? li.querySelector(":scope > .children") : null;

				if (box) {
					if (li.classList.contains("open")) {
						if (getComputedStyle(box).maxHeight === "none") {
							box.style.maxHeight = box.scrollHeight + "px";
						}
						requestAnimationFrame(function () {
							box.style.maxHeight = "0px";
						});
						li.classList.remove("open");
					} else {
						box.style.maxHeight = box.scrollHeight + "px";
						li.classList.add("open");
						box.addEventListener("transitionend", function t() {
							box.style.maxHeight = "none";
							box.removeEventListener("transitionend", t);
						});
					}
				}
			});
		});
	}

	if (deliveries) {
		deliveries.forEach((block) => {
			const toggle = block.querySelector(".single-product__summary-delivery-more");
			const content = block.querySelector(
				".single-product__summary-delivery-content"
			);

			if (!toggle || !content) return;

			toggle.addEventListener("click", () => {
				const isOpen = block.classList.toggle("is-open");

				if (isOpen) {
					content.style.maxHeight = content.scrollHeight + "px";
				} else {
					content.style.maxHeight = "0";
				}
			});
		});
	}

	if (burgerLines) {
		burgerLines.addEventListener("click", function () {
			if (burgerWrapper) {
				burgerWrapper.classList.add("active");
			}
		});
	}

	if (burgerClose) {
		burgerClose.addEventListener("click", function () {
			if (burgerWrapper) {
				burgerWrapper.classList.remove("active");
			}
		});
	}

	if (burgerWrapper) {
		burgerWrapper.addEventListener("click", function (e) {
			if (e.target === burgerWrapper) {
				burgerWrapper.classList.remove("active");
			}
		});
	}
});
